import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';


import GetRoleQuery from 'GraphQueries/Roles/GetQuery';
import NewReportQuery from 'GraphQueries/Reports/NewMutation';

import PageNavigationTabs from 'Components/Presentation/_Shared/Layout/PageNavigationTabs';
import RoleEdit from 'Components/Presentation/Roles/RoleEdit';

class RoleEditContainer extends React.Component {

    static defaultProps = {
        role: { name: '',},
        reports: [],
        loading: false,
        pageTabs: [
            { label: 'Back To List', path: 'list', includeId: false },
            { label: 'Settings', path: 'manage/settings', includeId: true },
            { label: 'Placement Classifications', path: 'manage/placement-classifications', includeId: true },
            { label: 'Reports', path: 'manage/reports', includeId: true }
        ]
    }
    state = { activeTabIndex: 1 }

    tabClickHandler = (el, key) => {
        const { history, match: { params } } = this.props;
        history.push(el.includeId ?
            `/organisations/roles/${params.id}/${el.path}` :
            `/organisations/roles/${el.path}`);
        this.setState({ activeTabIndex: key });
    }

    setActiveTab = index => {
        this.setState({ activeTabIndex: index });
    }
    saveRole = () => {
        const { role } = this.state;
        this.props.onUpdate(role);
    }
   

    render() {
        const { role, loading, pageTabs } = this.props;
        const { activeTabIndex } = this.state;
        return (
            <React.Fragment>
                <PageNavigationTabs pageTabs={pageTabs} activeTabIndex={activeTabIndex} onTabClick={this.tabClickHandler} />
                <Route path="/organisations/roles/:id/manage/settings" render={props =>
                    < RoleEdit role={role} loading={loading} saveHandler={this.saveRole} onActivate={event => this.setActiveTab(1)} />} />
            </React.Fragment>
        );
    }
}

export default
    compose(
        graphql(GetRoleQuery,
            {
                options: ({ match: { params: { id } } }) => ({
                    variables: { id },
                    fetchPolicy: 'network-only',
                }),
                props: ({ data: { getRole, loading } }) => ({
                    role: getRole,
                    reports: getRole && getRole.reports,
                    loading,
                }),
            }),
        graphql(NewReportQuery, {
            props: (props) => ({
                onAddReport: report => props.mutate({
                    variables: { ...report },
                    optimisticResponse: () => ({ createReport: { ...report, __typename: 'Report', version: 1 } }),
                })
            }),
            options: ({ match: { params: { id } } }) => ({
                refetchQueries: [{ query: GetRoleQuery, variables: { id } }],
                update: (dataProxy, { data: { createReport } }) => {
                    const query = GetRoleQuery;
                    const data = dataProxy.readQuery({ query, variables: { id } });

                    data.getRole.reports.push(createReport);

                    dataProxy.writeQuery({ query, data });
                }
            })
        })
    )(RoleEditContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Roles/Edit.js